import pie from "pistacja/plugin";
import Popover from "popover";
import CopyText from "copy-text";
import countdown from "countdown";

pie.plugin(function ExamLanding({ device }) {
  // Handle Popovers.
  Popover();

  // Handle [data-copy] buttons.
  CopyText();

  const timer = document.getElementById("countdown-timer");
  timer &&
    countdown(timer.dataset.time, (time) => {
      timer.innerHTML = time.toString();
    });
});
